import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import RolePresets from "@/components/RolePresets";

export default function RolePresetsSettings() {
  const [academies, setAcademies] = useState([]);
  const [selId, setSelId] = useState("");
  useEffect(() => {
    api.get("/me/academies").then((r) => {
      const adminOf = (r.data.academies || []).filter((a) => a.role === "admin");
      setAcademies(adminOf);
      setSelId(adminOf[0]?.academy_id || "");
    }).catch(() => setAcademies([]));
  }, []);

  if (academies.length === 0) {
    return (
      <div className="text-sm text-muted-foreground" data-testid="role-access-empty">
        Role permissions are set per academy. You need to be an <b>admin</b> of an academy to change these.
      </div>
    );
  }
  return (
    <div data-testid="role-access-settings">
      {academies.length > 1 && (
        <div className="mb-4 flex items-center gap-2 text-sm">
          <span className="text-muted-foreground">Academy:</span>
          <select data-testid="role-access-academy-select"
            value={selId} onChange={(e) => setSelId(e.target.value)}
            className="inp text-sm py-1.5">
            {academies.map((a) => (
              <option key={a.academy_id} value={a.academy_id}>{a.name || a.academy_id}</option>
            ))}
          </select>
        </div>
      )}
      {selId && <RolePresets academyId={selId} />}
    </div>
  );
}
